// extracted by mini-css-extract-plugin
export var category = "_j6-9";
export var categoryHeader = "_j6-e";
export var container = "_j6-0";
export var group = "_j6-a";
export var groupItems = "_j6-f";
export var groupSeparator = "_j6-j";
export var loading = "_j6-1";
export var noResults = "_j6-3";
export var placeholder = "_j6-2";
export var resultContent = "_j6-5";
export var resultIcon = "_j6-c";
export var resultItem = "_j6-g";
export var resultMeta = "_j6-8";
export var resultSubtitle = "_j6-7";
export var resultSuffix = "_j6-i";
export var resultTitle = "_j6-6";
export var resultsList = "_j6-4";
export var searchGroup = "_j6-d";
export var selected = "_j6-h";
export var subgroup = "_j6-b";